import { customStyled, Box, Button } from '@mafc/trolly';

export const ChangeCurrencyContainer = customStyled(Box)(
  ({ theme: { space } }: { theme: { space: number[] } }) => ({
    margin: `${space[3]}px ${space[1]}px`,
  })
);

export const StyledText = customStyled(Box)(
  ({ theme: { fontWeights, colors } }: { theme: { fontWeights: any; colors: any } }) => ({
    fontWeight: fontWeights[4],
    color: colors.black,
  })
);

export const HighlightedText = customStyled(Button)(({ theme: { fontWeights, colors } }) => ({
  fontWeight: fontWeights[7],
  color: colors.blue,
}));
